/**
 * @desc 更新计费类型为总价的报价
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: string,
  params: API.tms.logisticsQuotationTob.importLogisticsQuotationPrice.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/importLogisticsQuotationPrice`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
